import React, { ReactElement } from "react";
import { EuiFlexGroup, EuiFlexItem, EuiTitle, EuiTitleSize, EuiIcon } from "@elastic/eui";
import { createUseStyles } from "react-jss";

export type FDPanelTitleProps = {
  color?: string;
  fontWeight?: string;
  iconType?: string;
  rightActions?: ReactElement;
  title: string | ReactElement;
  titleSize?: EuiTitleSize;
  isHidden?: boolean;
  noSpace?: boolean;
  style?: React.CSSProperties;
  className?: string;
  iconColor?: string | undefined;
  rightContent?: any;
};

const panelTitleClasses = createUseStyles({
  title: {
    fontStyle: "normal !important",
    fontWeight: ({ fontWeight }: any) => fontWeight,
    lineHeight: "24px",
    whiteSpace: "nowrap",
  },
  icon: {
    marginRight: "8px",
  },
});

export const FDPanelTitle = React.memo<FDPanelTitleProps>(
  ({
    title,
    titleSize = "xs",
    fontWeight = "500 !important",
    color = "var(--text)",
    iconType,
    rightActions,
    noSpace = false,
    style,
    iconColor,
    rightContent,
  }) => {
    const classes = panelTitleClasses({ fontWeight });

    if (!title) return null;

    const titleStyle: React.CSSProperties = {
      fontSize: "var(--fs16)",
      color,
      ...style,
      ...(rightActions ? { whiteSpace: "normal" } : {}),
    };

    const titleNode = (
      <EuiTitle size={titleSize}>
        <span className={classes.title} style={titleStyle}>
          {iconType && (
            <EuiIcon
              type={iconType}
              //size={iconType === "dot" ? "l" : "m"}
              className={classes.icon}
              style={{ color: iconColor ?? "var(--text)" }}
            />
          )}
          {title}
        </span>
      </EuiTitle>
    );

    if (!rightActions) {
      return titleNode;
    }

    return (
      <EuiFlexGroup alignItems="center" responsive={false} gutterSize={noSpace ? "s" : "l"}>
        <EuiFlexItem>{titleNode}</EuiFlexItem>

        {!noSpace && <EuiFlexItem grow />}
        {rightContent && <EuiFlexItem grow={false}>{rightContent}</EuiFlexItem>}
        <EuiFlexItem grow={false}>{rightActions}</EuiFlexItem>
      </EuiFlexGroup>
    );
  }
);
